module.exports = __webpack_public_path__ + "img/3.3ce6b02e.jpg";